import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the updateLineComment method.
 */
export function createUpdateLineComment(context: API.Context) {
  /**
   * Update the line comment.
   */
  return function updateLineComment(comment: string | undefined, lineId: number): API.Response {
    const { game, respond } = context;

    game.updateLineComment(comment, lineId);

    return respond(Core.APIEvents.LineCommentUpdated, { comment, lineId });
  };
}
